<template>
	<div>
        <ValidationObserver ref="DateForm">
        <div class="row">
            <div class="col-12">
                <ValidationProvider name="coordinator_evaluation_finish_date" rules="required" v-slot="{ valid, errors }">
                    <b-form-group :label="$t('preference_date')">
                        <select-date v-model="coordinator_evaluation_finish_date" :validationError="errors[0]" />
                    </b-form-group>
                </ValidationProvider>
            </div>
            <div class="col-12">
                <b-button variant="primary" @click="saveDate">{{$t('save')}}</b-button>
            </div>
        </div>
        </ValidationObserver>
    </div>
</template>

<script>
	// Components
    import SelectDate from '@/components/interactive-fields/SelectDate';

	// Services
    import GraduateApplicationService from "@/services/GraduateApplicationService";

	// Other
	import {ValidationProvider, ValidationObserver} from "vee-validate"

	export default {
		components: {
			ValidationProvider,
			ValidationObserver,

            SelectDate
		},
		props: {
            row: {
                type: Object
            },
		},
		data() {
			return {
                coordinator_evaluation_finish_date: null
			}
		},
		watch: {
            row: function(val){
                this.coordinator_evaluation_finish_date = val.coordinator_evaluation_finish_date
            }
		},
		created() {

		},
		methods: {
            async saveDate(){
                if(this.checkPermission('graduateapplicationpreference_coordinatorevaluationdeadline')) {
                    const isValid = await this.$refs.DateForm.validate();
                    if (isValid) {
                        let formData = {
                            preference_id: this.row.perferenceId,
                            coordinator_evaluation_finish_date: this.coordinator_evaluation_finish_date
                        }
                        GraduateApplicationService.preferenceDateChange(this.row.perferenceId, formData).then(response => {
                            this.$toast.success(this.$t('api.'+response.data.message))
                            this.$emit('close',true)
                        }).catch(e => {
                            if (e.status == '404' || e.status == '406') {
                                if (e.data.message) {
                                    this.$toast.error(this.$t('api.'+e.data.message));
                                }
                            }
                        })
                    }
                }
            }
        }
	}
</script>
